/**
 * PSTUDIO-3624 — persistence for the "Expanded Cell View" panel open/closed
 * state. Kept as a tiny pure module (no MobX/store imports) so the localStorage
 * contract can be unit-tested in isolation, mirroring auto-renumber-storage.ts.
 * Default is closed (false).
 */
export const EXPANDED_CELL_VIEW_STORAGE_KEY = 'ps-expanded-cell-view-open';

export function loadExpandedCellViewOpen(): boolean {
  try {
    return localStorage.getItem(EXPANDED_CELL_VIEW_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function persistExpandedCellViewOpen(value: boolean): void {
  try {
    localStorage.setItem(EXPANDED_CELL_VIEW_STORAGE_KEY, String(value));
  } catch {
    // localStorage unavailable (private mode / denied / SSR / quota) —
    // non-fatal; the in-memory observable still drives this session.
  }
}
